import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function Configs() {
    const [configs, setConfigs] = useState({});
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [configContent, setConfigContent] = useState('');
    const [editingConfigName, setEditingConfigName] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchConfigs = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/api/configs/');
            setConfigs(response.data);
        } catch (err) {
            setError('Failed to fetch configs.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchConfigs();
    }, []);

    const handleSelectConfig = (name) => {
        setSelectedConfig(name);
        setEditingConfigName(name);
        setConfigContent(JSON.stringify(configs[name], null, 2));
    };
    
    const handleSaveConfig = async () => {
        setError('');
        let configData;
        try {
            configData = JSON.parse(configContent);
        } catch (e) {
            setError('Invalid JSON format.');
            return;
        }

        if (!editingConfigName) {
            setError("Config name cannot be empty.");
            return;
        }

        try {
            const originalName = selectedConfig && selectedConfig !== editingConfigName ? selectedConfig : undefined;
            await axios.post('/api/configs/save', { 
                name: editingConfigName, 
                config: configData,
                originalName: originalName
            });

            const response = await axios.get('/api/configs/');
            const newConfigs = response.data;
            setConfigs(newConfigs);
            
            setSelectedConfig(editingConfigName);
            setConfigContent(JSON.stringify(newConfigs[editingConfigName], null, 2));
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to save config.');
        }
    };
    
    const handleRemoveConfig = async (name) => {
        if (window.confirm(`Are you sure you want to delete config "${name}"?`)) {
            try {
                await axios.delete(`/api/configs/delete/${name}`);
                if (selectedConfig === name) {
                    setSelectedConfig(null);
                    setConfigContent('');
                }
                await fetchConfigs();
            } catch (err) {
                setError(err.response?.data?.error || 'Failed to delete config.');
            }
        }
    };
    
    const handleAddNew = () => {
        setSelectedConfig(null);
        setConfigContent('{}');
        setEditingConfigName('new_config');
    };

    return (
        <div>
            <h2>Manage Generation Configs</h2>
            {error && <p className="error-message">{error}</p>}
            
            <div className="configs-page">
                <div className="configs-list">
                    <h3>Available Configs</h3>
                    <button onClick={handleAddNew} style={{marginBottom: '1rem'}}>Add New</button>
                    {loading ? <p>Loading...</p> : (
                        <ul>
                            {Object.keys(configs).map(name => (
                                <li key={name} onClick={() => handleSelectConfig(name)} className={selectedConfig === name ? 'active' : ''}>
                                    {name}
                                    {name !== 'default_video_generation_config' && 
                                      <button onClick={(e) => {e.stopPropagation(); handleRemoveConfig(name)}} className="danger">X</button>
                                    }
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
                <div className="configs-editor form-container">
                    <h3>Editor</h3>
                    {(selectedConfig || editingConfigName) ? (
                         <div className="form-group">
                            <label>Config Name</label>
                            <input 
                              type="text" 
                              placeholder="my_awesome_config"
                              value={editingConfigName}
                              onChange={(e) => setEditingConfigName(e.target.value)}
                            />
                        </div>
                    ) : (
                        <h4>Select a config or add a new one</h4>
                    )}
                    <div className="form-group">
                        <textarea
                            value={configContent}
                            onChange={(e) => setConfigContent(e.target.value)}
                            style={{ height: '400px', fontFamily: 'monospace' }}
                        />
                    </div>
                    <button onClick={handleSaveConfig}>Save Config</button>
                </div>
            </div>
        </div>
    );
} 